import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject11(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Tarifa de alquiler");

    const sheet = context.workbook.worksheets.add("Tarifa de alquiler");

    // Title area (rows 1-2 merged across full table width)
    sheet.getRange("A1").values = [["Tarifas Alquiler"]];
    sheet.getRange("A1:D2").merge();
    sheet.getRange("A1").format.font.name = "Century Gothic";
    sheet.getRange("A1").format.font.size = 26;
    sheet.getRange("A1").format.font.bold = false;
    sheet.getRange("A1").format.horizontalAlignment = "Center";
    sheet.getRange("A1").format.verticalAlignment = "Center";
    sheet.getRange("1:1").format.rowHeight = 36;
    sheet.getRange("2:2").format.rowHeight = 36;

    // Table headers and data
    const headers = ["Artículo #", "Paquetes", "Día completo", "Medio día"];

    const data: (string | number)[][] = [
      [1, "Esquí Adulto", 27, 21],
      [2, "Esquí Junior", 20, 16],
      [3, "Esquí de Rendimiento", 39, 29],
      [4, "Esquí Demo", 59, 46],
      [5, "Esquí Nórdico", 27, 21],
      [6, "Snowblade", 25, 20],
      [7, "Esquí Bob", 50, 40],
      [8, "Bicicletas de Nieve", 275, 200],
      [9, "Moto de Nieve", 325, 275],
    ];

    const table = sheet.tables.add("A4:D4", true);
    table.name = "Tabla1";
    table.getHeaderRowRange().values = [headers];
    table.style = "TableStyleMedium7";
    table.rows.add(undefined, data);

    // Green header styling (student clears in Task 2)
    const headerRange = table.getHeaderRowRange();
    headerRange.format.fill.color = "#375623";
    headerRange.format.font.color = "#FFFFFF";
    headerRange.format.font.bold = true;

    // Currency format for Día completo and Medio día
    const lastRow = data.length + 4;
    sheet.getRange(`C5:D${lastRow}`).numberFormat =
      Array(data.length).fill(['$#,##0', '$#,##0']);

    // Column widths
    sheet.getRange("A:A").format.columnWidth = 70;
    sheet.getRange("B:B").format.columnWidth = 180;
    sheet.getRange("C:C").format.columnWidth = 100;
    sheet.getRange("D:D").format.columnWidth = 100;

    sheet.activate();
    sheet.getRange("A1").select();

    await context.sync();
  });
}
